module.exports = __webpack_public_path__ + "img/origin-home-person-background.465694ed.png";